/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Steamfitter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScenarioPermission = 'ViewScenario' | 'EditScenario' | 'ExecuteScenario' | 'ManageScenario' | 'ViewTasks';

export const ScenarioPermission = {
    ViewScenario: 'ViewScenario' as ScenarioPermission,
    EditScenario: 'EditScenario' as ScenarioPermission,
    ExecuteScenario: 'ExecuteScenario' as ScenarioPermission,
    ManageScenario: 'ManageScenario' as ScenarioPermission,
    ViewTasks: 'ViewTasks' as ScenarioPermission
};

